import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { getProveedoresExcel } from "../../../services";
import { withRouter } from "../../../providers/withRouter";
import Excel from "../../../icons/excel.svg";

// Botón "Generar listado": descarga el Excel de proveedores renderizado en el
// backend, aplicando los mismos filtros que la búsqueda activa.
const ExportarProveedoresLista = ({ busqueda = {}, filtroOrder = {} }) => {
  const { t } = useTranslation(["properties"]);
  const [isLoading, setIsLoading] = useState(false);

  const generarListado = async () => {
    setIsLoading(true);
    try {
      const blobData = await getProveedoresExcel({
        filtros: busqueda,
        params: {
          order: filtroOrder?.orden || "ASC",
          orderBy: filtroOrder?.ordenadoPor || "id",
        },
      });
      const blob = new Blob([blobData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      // Nombre con la fecha del día (dd-mm-aaaa)
      const hoy = new Date();
      const fecha = `${String(hoy.getDate()).padStart(2, "0")}-${String(hoy.getMonth() + 1).padStart(2, "0")}-${hoy.getFullYear()}`;
      link.setAttribute("download", `proveedores ${fecha}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
      toast.error(t("properties:management.excelError"));
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <span className="bigBtn" style={{ cursor: "context-menu" }}>
      <CircularProgress
        style={{ color: "#fff", width: "16px", height: "16px", marginRight: "10px" }}
      />{" "}
      {t("properties:management.generatingList")}
    </span>
  ) : (
    <button className="bigBtn" onClick={generarListado}>
      <img src={Excel} alt={t("properties:management.generateList")} width="30px" />{" "}
      {t("properties:management.generateList")}
    </button>
  );
};

export default withRouter(ExportarProveedoresLista);
